import useSearch from "./use_search";
import { useNavigate } from "react-router-dom";
import {
  IconChevronDown,
  IconSearch,
  IconExternalLink,
} from "@tabler/icons-react";
function Search() {
  const navigate = useNavigate();
  const search = useSearch();
  return (
    <div>
      <div>TODO: add date filters</div>
      <SearchInput
        searchString={search.searchString}
        setSearchString={search.setSearchString}
        onlyPaid={search.onlyPaid}
        setOnlyPaid={search.setOnlyPaid}
      />
      <div className="flex flex-col gap-2 p-4">
        {Array.from(search.state).map((item, idx) => (
          <div key={`items-${idx}`} className="border p-2 rounded-md flex">
            <button onClick={() => navigate(`/order/${item.order_id}`)}>
              <IconExternalLink />
            </button>
            <div className="my-auto ms-8">
              <div>
                {item.first_name} {item.last_name}
              </div>
              <div>{item.email}</div>
              <div>{item.phone_number}</div>
            </div>
            <div className="ms-auto">
              <div>
                <span className="font-bold">Created Date</span>:{" "}
                {new Date(item.created_date).toString()}
              </div>
              <div>
                <span className="font-bold">Paid Date </span>:{" "}
                {new Date(item.paid_date).toString()}
              </div>
              <div>
                <span className="font-bold">Ship Date </span>:{" "}
                {new Date(item.ship_date).toString()}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
function SearchInput({ searchString, setSearchString, onlyPaid, setOnlyPaid }) {
  return (
    <div>
      <div className="mt-2 p-4">
        <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
          <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm/6">
            <IconSearch />
          </div>
          <input
            type="text"
            placeholder="search..."
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            className="block min-w-0 grow ms-2 py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
          />
          <div className="grid shrink-0 grid-cols-1 focus-within:relative">
            <select
              id="currency"
              name="currency"
              aria-label="Currency"
              value={onlyPaid}
              onChange={(e) => setOnlyPaid(e.target.value)}
              className="col-start-1 row-start-1 w-full appearance-none rounded-md py-1.5 pl-3 pr-7 text-base text-gray-500 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            >
              <option value="paid">Paid</option>
              <option value="all">All</option>
            </select>
            <IconChevronDown
              aria-hidden="true"
              className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Search;
